module.exports = __webpack_public_path__ + "static/media/pizza-millano-cover.f1c2f3c9.jpg";